export default "__VITE_ASSET__7b236844__"